import { createAction, props } from '@ngrx/store';
import { DossierWorkflow } from './dossier-workflow.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records dossier workflow',
    props<{dossierId: string}>()
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records dossier workflow success', 
    props<{ listData: DossierWorkflow[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records dossier workflow failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record dossier workflow',
    props<{dossierId: string, id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record dossier workflow success', 
    props<{ singleData: DossierWorkflow }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record dossier workflow failure', 
    props<{ error: string }>()
);

// Add Data
export const addRecord = createAction(
    '[Data] Add record dossier workflow',
    props<{ dossierId: string, newData: any }>()
);

export const addRecordSuccess = createAction(
    '[Data] Add record dossier workflow success'
);

export const addRecordFailure = createAction(
    '[Data] Add record dossier workflow failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record dossier workflow',
    props<{ dossierId: string, id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record dossier workflow success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record dossier workflow failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record dossier workflow',
    props<{ dossierId: string, id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record dossier workflow success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record dossier workflow failure',
    props<{ error: string }>()
);


//HANDLE FLOW (For Pause and Resume)
export const handleFlow = createAction(
    '[Data] fetch single record dossier handle flow',
    props<{dossierId: string, shouldPause: number}>()
);

export const handleFlowSuccess = createAction(
    '[Data] fetch single record dossier handle flow success'
);

export const handleFlowFailure = createAction(
    '[Data] fetch single record dossier handle flow failure',
    props<{ error: string }>()
);

//RESTART WORKFLOW
export const restartWorkflow = createAction(
    '[Data] fetch single record dossier restart workflow',
    props<{dossierId: string}>()
);

export const restartWorkflowSuccess = createAction(
    '[Data] fetch single record dossier restart workflow success'
);

export const restartWorkflowFailure = createAction(
    '[Data] fetch single record dossier restart workflow failure',
    props<{ error: string }>()
);


//RESEND WORKFLOW STEP (For Pause and Resume)
export const resendWorkflowStep = createAction(
    '[Data] resend workflow step',
    props<{stepId: string}>()
);

export const resendWorkflowStepSuccess = createAction(
    '[Data] resend workflow step success'
);

export const resendWorkflowStepFailure = createAction(
    '[Data] resend workflow step failure',
    props<{ error: string }>()
);


//Reset State
export const resetState = createAction(
    '[Data] reset state dossier workflow',
);